import { apiFetch, getToken } from './client';

export const getAto            = (systemId)        => apiFetch(`/ato?system_id=${systemId}`);
export const updateAto         = (systemId, data)  => apiFetch(`/ato?system_id=${systemId}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const getControls       = (systemId, params={}) => apiFetch(`/ato/controls?${new URLSearchParams({ system_id: systemId, ...params })}`);
export const getFamilySummary  = (systemId)        => apiFetch(`/ato/controls/families?system_id=${systemId}`);
export const addControl        = (systemId, data)  => apiFetch(`/ato/controls?system_id=${systemId}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateControl     = (systemId, id, data) => apiFetch(`/ato/controls/${id}?system_id=${systemId}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const removeControl     = (systemId, id)   => apiFetch(`/ato/controls/${id}?system_id=${systemId}`, { method: 'DELETE' });
export const exportControls    = (systemId)        => window.open(`/api/ato/export/controls?system_id=${systemId}`, '_blank');
export const exportTestResults = (systemId)        => window.open(`/api/ato/export/testresults?system_id=${systemId}`, '_blank');
export const uploadAtoLetter   = (systemId, file)  => {
  const form = new FormData();
  form.append('file', file);
  const token = getToken();
  return fetch(`/api/ato/upload-letter?system_id=${systemId}`, {
    method: 'POST', body: form,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  }).then(r => r.json().then(d => r.ok ? d : Promise.reject(d)));
};
